// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__3-eaz","right":"styles_right__10pjy"};